export default __webpack_public_path__ + "static/media/CarvestTime.14e0671e.png";